import { Component, ViewChild, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { NavController, NavParams, App } from 'ionic-angular';
import { TableDirective } from '../../directives/table-directive';
import { PaytronBackendService } from '../../providers/paytron-backend/paytron-backend.service';
import { NavControllerService } from '../../providers/nav-controller/navControllerService';
import { HttpErrorResponse } from '@angular/common/http';
import { Zone } from '../../app/models/Zone';
import { ModalDirective } from 'ngx-bootstrap';
import { NgForm } from '@angular/forms';
import { Storage } from '../../../node_modules/@ionic/storage';

@Component({
  selector: 'page-zones',
  templateUrl: 'zones.html',
})
export class ZonesPage implements AfterViewInit, OnDestroy, OnInit {
  @ViewChild(TableDirective)
  private table: TableDirective;

  @ViewChild('zoneModal')
  private zoneModal: ModalDirective;

  @ViewChild('deleteModal')
  private confirmModal: ModalDirective;

  @ViewChild('zoneForm')
  private zoneForm: NgForm;

  private pageName: string = 'page-zones';
  private zones: Zone[] = [];
  private currentZone = new Zone();

  private navControllerService: NavControllerService;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private app: App,
    private backendService: PaytronBackendService,
    private storage: Storage
  ) {
    this.navControllerService = new NavControllerService(app, storage);
  }

  ngOnInit(): void {
    this.table.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
    };
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {}

  ionViewDidEnter() {
    this.getZones();
  }

  private getZones() {
    this.backendService.getZones().subscribe(
      (zones) => {
        this.zones = zones;
        this.table.refreshTable();
      },
      (err: HttpErrorResponse) => {}
    );
  }

  onSearchChange(searchString) {
    this.table.filterBySearchText(searchString);
  }

  addZone() {
    this.currentZone = new Zone();
    this.zoneForm.resetForm();
    this.showZoneModal();
  }

  editZone(zone: Zone) {
    this.currentZone = zone;
    this.showZoneModal();
  }

  deleteZone() {
    this.backendService
      .deleteZone(this.currentZone)
      .subscribe(
        (data) => {
          this.getZones();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        this.closeConfirmModal();
      });
  }

  submitZone(btnEvent: HTMLButtonElement) {
    btnEvent.disabled = true;
    this.backendService
      .saveOrUpdateZone(this.currentZone)
      .subscribe(
        (zone) => {
          this.getZones();
        },
        (err: HttpErrorResponse) => {}
      )
      .add(() => {
        btnEvent.disabled = false;
        this.closeZoneModal();
      });
  }

  showZoneModal() {
    this.zoneModal.show();
  }

  closeZoneModal() {
    this.zoneModal.hide();
  }

  showConfirmModal(zone) {
    this.currentZone = zone;
    this.confirmModal.show();
  }

  closeConfirmModal() {
    this.confirmModal.hide();
  }

  showPosPage() {
    this.navControllerService.showPosPage();
  }

  showPosAppPage() {
    this.navControllerService.showPosAppPage();
  }
}



// WEBPACK FOOTER //
// ./src/pages/zones/zones.ts